import { Alert, Box, Button, Checkbox, Collapse, FormControl, FormControlLabel, FormGroup, FormLabel, Radio, RadioGroup, TextField } from '@mui/material';
import React, { useContext, useState } from 'react';
import Capa from '../../Controls/Capa/Capa';
import './ImagenView.css'
import UploadIcon from '@mui/icons-material/Upload';

import { addImage } from '../../../Service/imagen'
import { AuthContext } from '../../../Context/AuthContext';

function ImagenView(props) {

    const [pathImage, setPathImage] = useState();

    const { accessToken } = useContext(AuthContext);

 //DIALOG METODOS MSJ ********************
    //Open Close
    const [openMsj, setOpenMsj] = useState(false)
    //Msj Error
    const [msjTitle, setMsjTitle] = useState("")

    const MsjElement = ({severityProp}) => {
      return (
            <Collapse in={openMsj}>
              <Alert severity={severityProp} onClose={()=>{setOpenMsj(false)}}>
                {msjTitle}
              </Alert>
            </Collapse>
          );
    };

    //DIALOG METODOS MSJ ********************

    const onChange = (e) => {
        
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = function load() {
            setPathImage(reader.result);
        }
    }

    const onAceptar = (e) => {
        e.preventDefault();

        const formData = new FormData(e.currentTarget);

        if (formData.get("EsDefault") === "on") { formData.set("EsDefault", -1) }
        else { formData.set("EsDefault", 0) }

        const file = formData.get("FileStream");

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = function load() {
            const base64 = reader.result.split(',')[1];
            formData.append("FileStream", base64);
            const frmImgInsertRequest = Object.fromEntries(formData);

            const datos = {frmImgInsertRequest}

            addImage(datos, accessToken)
                .then(data => {
                    if(data != undefined && data.Message != undefined && (data.Message.includes("Error") || data.Message.includes("errores"))){
                        setMsjTitle(data.Message);
                        setOpenMsj(true);    
                        return;
                    }else{
                        
                        props.pInit();
                        props.handleClose();                    
                    }

                }).catch(
                    error => { 
                        setMsjTitle(error.toString());
                        setOpenMsj(true);
                    }); 

        }
    }

    return (
        <Box component={'form'} onSubmit={onAceptar}>
            <Capa onCancel={props.handleClose} title={"Imagen"}>
                <div className='frm-container'>
                    <section className='img-container'>
                        <img src={pathImage?pathImage:"./img/img-default.png"} alt="img-default"/>

                        <section className='opt-container'>
                            <div className='opt-upload'>
                                <Button variant="contained"><label htmlFor="archivo"><UploadIcon /></label></Button>
                                <input className='input-file' name="FileStream" accept="image/*" id="archivo" type="file" onChange={onChange} required/>
                            </div>

                            {/*radio button para seleccionar el tipo*/}
                            <FormControl className='img-options'>
                                <FormLabel id="demo-radio-buttons-group-label">Tipo</FormLabel>
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue="L"
                                    name="Tipo"
                                >
                                    <FormControlLabel value="L" control={<Radio />} label="Logo" />
                                    <FormControlLabel value="F" control={<Radio />} label="Firma" />
                                </RadioGroup>
                            </FormControl>

                            <FormGroup sx={{ ml: 4 }}>
                                <FormControlLabel name='EsDefault' control={<Checkbox />} label="Es Default" />
                            </FormGroup>

                        </section>

                    </section>

                    <TextField sx={{ mt: 2 }} id="outlined-basic" name="Descripcion" label="Descripción" variant="outlined" autoComplete="off" required />
                </div>
                <MsjElement severityProp="error"></MsjElement>   
            </Capa>
        </Box>


    );
}

export default ImagenView;